<template>
  <v-app>
    <v-content
      id="pages"
      :class="$vuetify.theme.dark ? undefined : 'grey lighten-3'"
    >
      <v-img
        :class="{
          'v-image--sm': this.$vuetify.breakpoint.smAndDown,
          'v-image--md': this.$vuetify.breakpoint.mdAndDown
        }"
        :src="require(`@/assets/login.jpg`)"
        gradient="to top, rgba(0, 0, 0, .5), rgba(0, 0, 0, .5)"
        min-height="100%"
      >
        <v-container
          id="oidc-callback"
          class="fill-height"
          tag="section"
        >
          <v-row justify="center">
            <v-slide-y-transition appear>
              <v-card
                class="mt-6 mt-md-0"
                light
                max-width="100%"
                width="250"
              >
                <v-card-text class="text-center">
                  <v-progress-circular
                    :size="70"
                    :width="7"
                    color="purple"
                    indeterminate
                  />

                  <div class="display-2 font-weight-light mb-3 text--darken-2 grey--text">
                    Logging In...
                  </div>
                </v-card-text>
              </v-card>
            </v-slide-y-transition>
          </v-row>
        </v-container>
      </v-img>
    </v-content>
  </v-app>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'OidcCallback',
    created () {
      this.oidcSignInCallback()
        .then((redirectPath) => {
          this.$router.push(redirectPath)
        })
        .catch((err) => {
          console.error(err)
          this.$router.push('/oidc-callback-error') // Handle errors any way you want
        })
    },
    methods: {
      ...mapActions('oidcStore', [
        'oidcSignInCallback',
      ]),
    },
  }
</script>

<style lang="sass">
  #pages
    > .v-content__wrap > .v-image
      padding-top: 64px
      padding-bottom: 88px

    .v-responsive__sizer
      display: none

    .v-image--md
      padding: 188px 0

    .v-image--sm
      padding: 96px 0 188px 0
</style>
